import MonitorMap from "./MonitorMap";

export default {
  list: MonitorMap,
};
